import { useState } from "react";
import { crearMedico } from "../../api/apiResources";
import "./CrearMedicoModal.css";

const CrearMedicoModal = ({ onClose, onSuccess }) => {
    const [formData, setFormData] = useState({
        nombre: "",
        apellido: "",
        matricula: "",
        activo: true,
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        try {
            const medicoPayload = {
                nombre: formData.nombre.trim(),
                apellido: formData.apellido.trim(),
                matricula: formData.matricula.trim(),
                activo: formData.activo,
            };

            await crearMedico(medicoPayload);

            onSuccess();
            onClose();
        } catch (err) {
            setError(err.response?.data?.error || err.message || "Error al crear médico");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Crear Nuevo Médico</h2>
                {error && <div className="modal-error">{error}</div>}

                <form onSubmit={handleSubmit} className="crear-medico-form">
                    <label>
                        Nombre:
                        <input
                            type="text"
                            name="nombre"
                            value={formData.nombre}
                            onChange={handleChange}
                            minLength={3}
                            maxLength={50}
                            required
                        />
                    </label>
                    <label>
                        Apellido:
                        <input
                            type="text"
                            name="apellido"
                            value={formData.apellido}
                            onChange={handleChange}
                            minLength={3}
                            maxLength={50}
                            required
                        />
                    </label>
                    <label>
                        Matrícula:
                        <input
                            type="text"
                            name="matricula"
                            value={formData.matricula}
                            onChange={handleChange}
                            minLength={5}
                            maxLength={20}
                            required
                        />
                    </label>
                    <label className="crear-medico-form__checkbox">
                        <input
                            type="checkbox"
                            name="activo"
                            checked={formData.activo}
                            onChange={handleChange}
                        />
                        Activo
                    </label>

                    <div className="modal-actions">
                        <button type="button" onClick={onClose} disabled={loading} className="btn-cancel">
                            Cancelar
                        </button>
                        <button type="submit" disabled={loading} className="btn-submit">
                            {loading ? "Creando..." : "Crear médico"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CrearMedicoModal;